/**
 * Centralized error guard functions
 * These are used across the codebase to identify specific error types
 * Kept separate to avoid circular dependencies (logger ↔ queryErrorUtils)
 */

/**
 * Centralized guard for AbortError detection
 * AbortErrors occur when requests are cancelled (e.g., component unmount, navigation)
 * These are expected behavior and should not be logged as errors
 *
 * @param error - The error to check
 * @returns true if the error is an AbortError or signal abort
 */
export function isAbortError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.name === 'AbortError' || error.message?.includes('signal is aborted');
}

/**
 * Guard for AuthSessionMissingError
 * These occur when a user is not logged in and are expected in certain flows
 *
 * @param error - The error to check
 * @returns true if the error is an AuthSessionMissingError
 */
export function isAuthSessionMissingError(error: unknown): boolean {
  return error instanceof Error && error.name === 'AuthSessionMissingError';
}
